import React from 'react';
import { Button } from 'folds';
import { AsyncStatus } from '../../hooks/useAsyncCallback';
import { useDocArea } from '../../contexts/DocAreaContext';
import { useTranslation } from 'react-i18next';

export function DocAreaPanel() {
  const { t } = useTranslation();
  const { docInfo, showDocArea, docopen, setDocopen, setPressed, closeDocArea } = useDocArea();

  const panelStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'var(--curve-bg-white, #FFFFFF)',
  };

  if (docInfo?.hasOwnProperty('pdfViewer') && (docInfo.pdfViewer as boolean)) {
    return (
      <div style={panelStyle}>
        {showDocArea && (docInfo?.pdfState as { status: string })?.status === AsyncStatus.Success ? (
          <div style={{ flex: 1, overflow: 'auto' }}>
            {(docInfo.renderViewer as (opts: { name: string; src: unknown; requestClose: () => void }) => React.ReactNode)({
              name: docInfo.body as string,
              src: (docInfo.pdfState as { data: unknown }).data,
              requestClose: closeDocArea,
            })}
          </div>
        ) : (
          <div style={{ flex: 1 }} />
        )}
      </div>
    );
  }

  if (docInfo?.hasOwnProperty('imageViewer') && (docInfo.imageViewer as boolean)) {
    return (
      <div style={{ ...panelStyle, overflow: 'auto' }}>
        {showDocArea &&
          (docInfo.renderViewer as (opts: { alt: string; src: string; requestClose: () => void }) => React.ReactNode)({
            alt: docInfo.body as string,
            src: docInfo.src as string,
            requestClose: closeDocArea,
          })}
      </div>
    );
  }

  if (docInfo?.hasOwnProperty('RepairInfo') && docopen) {
    const repairInfo = docInfo.RepairInfo as Record<string, string>;
    return (
      <div style={panelStyle}>
        {repairInfo?.hasOwnProperty('htmldoc') && (
          <>
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <iframe
                srcDoc={repairInfo.htmldoc}
                width="100%"
                height="100%"
                style={{ border: 'none', display: 'block' }}
              />
            </div>
            <div style={{ padding: '10px', flexShrink: 0, textAlign: 'right' }}>
              <Button
                onClick={() => {
                  setDocopen(false);
                  setPressed(true);
                }}
                variant="Primary"
              >
                {t('Common.close')}
              </Button>
            </div>
          </>
        )}
      </div>
    );
  }

  return null;
}
